module.exports = __webpack_public_path__ + "img/plan1.682790ab.jpg";